// IMPORTANT: Must remain the first import.
// setupErrors installs global error handlers before React Error Overlay
// registers its own listeners. Moving this import may allow harmless
// ResizeObserver errors to trigger the development overlay.
import './setupErrors';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'rsuite/dist/rsuite.min.css';
import { applyTenantTheme } from './config/tenant';
import App from './App';

import './index.scss';

// Apply tenant theme before React render to prevent FOUC
applyTenantTheme();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
